import api from '../services/api';

export const ordersAPI = {
  getAll: (params) => api.get('/orders', { params }),
  getById: (id) => api.get(`/orders/${id}`),
  create: (data) => api.post('/orders', data),
  update: (id, data) => api.put(`/orders/${id}`, data),
  delete: (id) => api.delete(`/orders/${id}`),

  // Dashboard KPIs
  getRevenue: (params) => api.get('/orders/stats/revenue', { params }),
  getStats: (params) => api.get('/orders/stats', { params }),
  getRecentActivity: (params) => api.get('/orders/recent-activity', { params }),
};

export default ordersAPI;
